import { useContext } from 'react'
import { CompareProductsContext } from '~/providers'

export const useCompareProducts = () => {
  return useContext(CompareProductsContext)
}
